import React, { FC } from "react";
import { Box, Drawer, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { globalStyles } from "../styles/GlobalStyles";

interface SideDrawerProps {
  visible?: boolean;
  onClose?: () => void;
  title?: string;
  subTitle?: string | null;
  children?: React.ReactNode;
}

const SideDrawer: FC<SideDrawerProps> = ({
  visible,
  onClose,
  title,
  subTitle,
  children,
}) => {
  return (
    <Drawer
      anchor="right"
      open={visible}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: styles.drawer,
        },
      }}
    >
      {/* Header */}
      <Box
        p={3}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <Typography fontSize={22}>{title}</Typography>
          {subTitle && <Typography fontSize={21}>{subTitle}</Typography>}
        </div>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {children}
    </Drawer>
  );
};

export const SideDrawerBody = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box sx={[globalStyles.flex1, { flexDirection: "column", mx: 3 }]}>
      {children}
    </Box>
  );
};

export const SideDrawerFooter = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <div>{children}</div>;
};

const styles = {
  drawer: {
    width: 520,
    transition: "width 0.3s ease",
    borderRadius: "5px 0 0 5px",
    overflow: "auto",
    backgroundColor: "custom.background.secondary",
  },
};

export default SideDrawer;
